import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleryComponent } from './gallery.component';
import { ImgHeaderModule } from '../../img-header/img-header.module';
import { Angular2ImageGalleryModule } from 'angular2-image-gallery/app/angular2imagegallery.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ImgHeaderModule,
    Angular2ImageGalleryModule,
    SharedModule
  ],
  declarations: [ GalleryComponent ]
})
export class GalleryModule { }



// WEBPACK FOOTER //
// ./src/app/pages/gallery/gallery.module.ts